import { render } from "./LineChartF.vue?vue&type=template&id=1dc01846&scoped=true"
import script from "./LineChartF.vue?vue&type=script&lang=ts"
export * from "./LineChartF.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1dc01846"

export default script